import styled from 'styled-components'

export const StyledAppliedFiltersWrapper = styled.div`
    display: flex;
    flex-direction: ${props => props.orientation === 'vertical' ? 'column' : 'row'};
    align-items: ${props => props.orientation === 'horizontal' ? 'center' : undefined};
    gap: var(--bq-spacing-xs);
`

export const StyledAppliedFiltersTags = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: var(--bq-spacing-xs);
`
